import React, { useState, useEffect } from 'react';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import { useTranslation } from "react-i18next";
import dayjs from 'dayjs';
import 'dayjs/locale/id';
import { useCookies } from 'react-cookie';
import { useNavigate } from 'react-router-dom';

const Section9 = () => {
	const [cookies] = useCookies(['i18next']);
	const formatDate = (date, locale = 'en') => {
		dayjs.locale(locale); // Set the locale dynamically
		return dayjs(date).format('DD MMMM YYYY'); // Format the date
	};
	const { t } = useTranslation();
	const navigate = useNavigate();

	const [data, setData] = useState([]);
	useEffect(() => {
		fetch(process.env.REACT_APP_API_URL + process.env.REACT_APP_API_DATA)
			.then((resp) => {
				if (!resp.ok) throw new Error("Failed to fetch data");
				return resp.json();
			})
			.then((rows) => {
				const arr = rows.map((element) => ({
					icon: '🌐',
					title: element?.title,
					title_en: element?.title_en || element?.title, // Default to original title
					value: parseInt(element?.amount).toLocaleString('id-ID'),
					unit: 'Data',
					date: element?.date_created.split('T')[0],
				}));
				setData(arr);
			})
			.catch((error) => console.error("Error fetching statistics:", error));
	}, []);

	if (data.length > 0) {
		var options = {
			loop: true,
			margin: 10,
			dots: true,
			autoplay: true,
			nav: true,
			navText: [
				"<i class='custom-prev fas fa-chevron-left'></i>",
				"<i class='custom-next fas fa-chevron-right'></i>"
			],
			responsive: {
				0: {
					items: 1,
					margin: 0
				},
				576: {
					items: 2,
					margin: 5
				},
				768: {
					items: 3,
					margin: 8
				},
				992: {
					items: 4,
					margin: 10
				}
			},
		};
	}

	return (
		<section className='funfact-section'>
			<div className='container'>
				<div className='blog-box' style={{ paddingBottom: "50px" }}>
					<div className='section-title-box text-center' data-aos="flip-up">
						<h2 className='section-title text-white'>
							{t("statistik_slider")}
						</h2>
					</div>
				</div>
				<OwlCarousel className="owl-theme custom-carouselx" loop={true} nav={true} dots={true} {...options} data-aos="fade-down-left">
					{data.map((item, index) => (
						<div
							key={index}
							className="item px-2"
						>
							<a
								href={`/data`}
								className="text-decoration-none"
							>
								<div className="card bg-light border-0 shadow p-3">
									<div className="card-body text-center">
										<i className="fas fa-briefcase fa-3x mb-3"></i>
										<h5
											style={{
												fontSize: '17px',
												minHeight: '48px',
												display: '-webkit-box',
												WebkitLineClamp: '2',
												WebkitBoxOrient: 'vertical',
												// overflow: 'hidden',
												// textOverflow: 'ellipsis'
											}}
											className="card-title mb-3"
										>
											{cookies.i18next === 'id'
												? item.title
												: item.title_en}
										</h5>
										<h3 className="card-text mb-2">{item.value}</h3>
										<p className="card-text text-muted mb-0">
											{cookies.i18next === 'id'
												? formatDate(item.date, 'id')
												: formatDate(item.date, 'en')}
										</p>
									</div>
								</div>
							</a>
						</div>
					))}
				</OwlCarousel>

				{/* Pembungkus tombol diubah menjadi row agar berjejer ke samping */}
				<div
					className="selengkapnya"
					data-aos="fade-down-left"
					style={{
						display: 'flex',
						flexDirection: 'row',
						flexWrap: 'wrap',
						justifyContent: 'center',
						alignItems: 'stretch',
						gap: '20px',
						marginTop: '30px'
					}}
				>
					{/* Tombol Baru: Logo Jabar & Keterangan (Mengarah ke KNEKS) */}
					<a
						href={`/data?tab=anugrah-adinata`}
						target="_blank"
						rel="noopener noreferrer"
						className="btn btn-light shadow-sm"
						style={{
							display: 'flex',
							flexDirection: 'column',
							justifyContent: 'center',
							alignItems: 'center',
							padding: '15px 25px',
							borderRadius: '8px',
							textDecoration: 'none',
							color: '#333',
							backgroundColor: '#fff',
							width: 'fit-content'
						}}
					>
						<span style={{ fontSize: '13px', fontWeight: 'bold', textAlign: 'center' }}>
							Juara Umum
						</span>

						<img
							src="/assets/image/west_java_logo.png"
							alt="Logo Jawa Barat"
							style={{ width: '150px', height: 'auto', marginBottom: '8px', marginTop: '8px' }}
						/>
						<span style={{ fontSize: '13px', fontWeight: 'bold', textAlign: 'center' }}>
							Anugerah Adinata Syariah 2026
						</span>
					</a>

					<a
						href={`/data?tab=simulator`}
						target="_blank"
						rel="noopener noreferrer"
						className="btn btn-light shadow-sm"
						style={{
							display: 'flex',
							flexDirection: 'column',
							justifyContent: 'center',
							alignItems: 'center',
							padding: '15px 25px',
							borderRadius: '8px',
							textDecoration: 'none',
							color: '#333',
							backgroundColor: '#fff',
							width: 'fit-content'
						}}
					>
						<img
							src="/assets/image/simulator_insentif.png"
							alt="Logo Simulator Insentif"
							style={{ width: '150px', height: 'auto', marginBottom: '8px', marginTop: '8px' }}
						/>
						<span style={{ fontSize: '13px', fontWeight: 'bold', textAlign: 'center' }}>
							Simulator Insentif Industri Halal
						</span>
					</a>
				</div>
				{/* <div className="d-flex justify-content-center" data-aos="fade-down-left" style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: '20px', marginTop: '30px' }}>
					<button
						className="btn-custom"
						style={{ '--clr': '#0F21BA' }}
						onClick={() => navigate('/data?tab=simulator')}
					>
						<span className="button-decor"></span>
						<span className="button-content">
							<span className="button__icon">
								<i className="fa-solid fa-calculator"></i>
							</span>
							<span className="button__text">Simulator Insentif Industri Halal</span>
						</span>
					</button>
				</div> */}
			</div>
		</section>
	);
};

export default Section9;